import { useCallback, useEffect, useState } from "react";
import AgentPreferencesAPI from "../api/AgentPreferencesAPI";

const useAgentPreferenceForAgent = (agentId) => {
	const [submission, setSubmission] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const refresh = useCallback(async () => {
		if (!agentId) {
			setSubmission(null);
			setLoading(false);
			return;
		}

		setLoading(true);
		setError(null);

		try {
			const result = await AgentPreferencesAPI.getAllSubmissions(agentId);
			setSubmission(result?.submissions?.[0] || null);
		} catch (err) {
			setError(err.message);
		} finally {
			setLoading(false);
		}
	}, [agentId]);

	useEffect(() => {
		refresh();
	}, [refresh]);

	const review = async (submissionId, status) => {
		try {
			await AgentPreferencesAPI.reviewSubmission(submissionId, status);
			await refresh();
			return { success: true };
		} catch (err) {
			return { success: false, error: err.message };
		}
	};

	return { submission, loading, error, refresh, review };
};

export default useAgentPreferenceForAgent;
